export default function StreamInputDescExternalBus({ input }) {
  return <>EXT BUS {input.bus_id} →</>;
}
